export default async (messageBus) => {
  if (!messageBus) {
    messageBus = await import('@wh/message-bus');
  }

  const messagingApp = (await import('@wh/overlay-messaging')).default;
  const cookieDisclaimerUi = (await import('@wh/overlay-cookieDisclaimer')).default;

  cookieDisclaimerUi(messageBus);
  messagingApp(messageBus);
};
